export enum StatusConnectionEnum {
  Connecting = 'connecting',
  ConnectionFailed = 'connection failed',
  Connected = 'connected'
}
